import { FileErrorStatus, FileStatus } from '../types';
export const formatBytes = (bytes) => {
    if (bytes === 0) {
        return '0 Bytes';
    }
    if (bytes === 1) {
        return '1 Byte';
    }
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(0))} ${sizes[i]}`;
};
export const getAcceptsDescription = (accept) => {
    const keys = Object.keys(accept);
    const types = keys.map((type) => type.replace(/(^\w+\/)/, '').toUpperCase());
    if (types.length > 1) {
        return `${types.slice(0, -1).join(', ')} or ${types.slice(-1)}`;
    }
    return types.join(', ');
};
const getDefaultErrors = (maxSize, maxFiles) => {
    return {
        [FileErrorStatus.FileMaxExceeded]: `The file you are trying to upload exceeds the ${formatBytes(maxSize)} size limit.`,
        [FileErrorStatus.MaxFilesExceeded]: `The number of files you are trying to upload exceeds the ${maxFiles} file limit.`,
    };
};
export const getErrorMap = (maxSize, maxFiles, errors) => {
    return {
        ...getDefaultErrors(maxSize, maxFiles),
        ...errors,
    };
};
export const getValidFilesCount = (files) => {
    return Object.values(files).filter((file) => [FileStatus.Success, FileStatus.Idle].includes(file.status)).length;
};
